// apps/client/src/ui/i18n.ts — one place to swap locales later (spec §8.5)
import { t, type StringKey, type StringParams } from '@whiskerton/content';
export function useT(): (key: StringKey, params?: StringParams) => string { return t; }
/** An item's name as a label or title: its catalog name string, sentence-cased (fish names are lowercase for use mid-sentence). */
export function itemName(nameKey: string): string {
  const s = t(nameKey as StringKey);
  return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}
